import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=67d7173b&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67d7173b')) {
      api.createRecord('67d7173b', component.options)
    } else {
      api.reload('67d7173b', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=67d7173b&", function () {
      api.rerender('67d7173b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sHEF85j150bo/JS/pricehelp.vue"
export default component.exports